export const gtmEvents = {
  SEND_FORM_SUCCESS: 'send_form_success',
}
